__webpack_require__.p = "https://portal.acquisdata.brixmind.com/";